import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getBase64Document,
  getPDFDocument,
} from "../../../redux/descriptorsProfiles/GeneralInfo/actions";
import DocumentoDescriptorPDFComponent from "../../../components/descriptorsProfiles/DocumentoDescriptorPDF";

const DocumentoDescriptorPDF = (props) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const dispatch = useDispatch();

  const { loadingPdfDocument } = useSelector((store) => store.generalInfo);

  // Métodos
  useEffect(() => {
    if (props.match.params.id) {
      dispatch(getBase64Document(parseInt(props.match.params.id)));
      dispatch(getPDFDocument(parseInt(props.match.params.id), {}));
    }
  }, [props.match.params.id]);

  return (
    <>
      {/* <Row className="mx-1 px-2 py-3 d-flex flex-wrap align-items-center">
        <b>
          Enlace de descarga (Word):{" "}
          {!loadingDescriptionManual && (
            <a
              href={`data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${
                docDescriptor ? docDescriptor.documento : ""
              }`}
              download={props.nombre}
              target="_blank"
              className="btn btn-link"
              rel="noreferrer"
            >
              aquí
            </a>
          )}
        </b>
        {loadingDescriptionManual && (
          <Col sm="2">
            <Spinner animation="border" size="sm" />
          </Col>
        )}
      </Row> */}
      <Row className="mx-1 px-2 py-3 d-flex flex-wrap align-items-center">
        <b>
          Enlace de descarga (PDF):{" "}
          <DocumentoDescriptorPDFComponent
            id={props.match.params.id}
            setLoadingPrint={setLoadingPrint}
            loadingPrint={loadingPrint}
            nombre={props.match.params.nombre}
          />
        </b>
        {loadingPdfDocument || loadingPrint ? (
          <Col sm="2">
            <Spinner animation="border" size="sm" />
          </Col>
        ) : null}
      </Row>
    </>
  );
};

export default DocumentoDescriptorPDF;
